/**
 * Singbac Incorporation Post — live UI 값 → Word 렌더용 정규화.
 *
 * Singbac 7종 템플릿은 대부분 단순 [[변수]] 치환이며 조건 체크박스(☒/☐)는 문서마다
 * 고정이라 별도 계산이 없다. 반복부는 DRIW 의 subscribers(주주 등록표) 하나뿐이므로
 * 화면 키 sub{id}_member_* → subscribers[] 배열을 만들어 준다.
 * 회사명·등록주소 별칭도 함께 보정해 미치환(빈칸)을 없앤다.
 */
function txt(v: unknown): string {
  return v == null ? '' : String(v).trim();
}
function isFilled(v: unknown): boolean {
  return v != null && String(v).trim() !== '';
}

/** sub{id}_member_* → subscribers[] ([[if subscribers]] … [[/if subscribers]]) */
function buildSubscribers(out: Record<string, any>) {
  if (Array.isArray(out.subscribers) && out.subscribers.length) return;
  const rows: Record<string, any>[] = [];
  for (let i = 1; i <= 30; i++) {
    const name = out[`sub${i}_member_name`];
    const shares = out[`sub${i}_member_shares`];
    const price = out[`sub${i}_member_issue_price`];
    const cap = out[`sub${i}_member_issued_capital`];
    if (!isFilled(name) && !isFilled(shares) && !isFilled(price) && !isFilled(cap)) continue;
    rows.push({
      member_name: txt(name),
      member_shares: txt(shares),
      member_issue_price: txt(price),
      member_issued_capital: txt(cap),
    });
  }
  if (rows.length) out.subscribers = rows;
}

/** s156_{n}_firm/_nature → s156[] ([[if s156]] … [[/if s156]]) — Disclosure(s156) 회사/펌 반복부 */
function buildS156(out: Record<string, any>) {
  if (Array.isArray(out.s156) && out.s156.length) return;
  const rows: Record<string, any>[] = [];
  for (let i = 1; i <= 30; i++) {
    const firm = out[`s156_${i}_firm`];
    const nature = out[`s156_${i}_nature`];
    if (!isFilled(firm) && !isFilled(nature)) continue;
    rows.push({ firm: txt(firm), nature: txt(nature) });
  }
  if (rows.length) out.s156 = rows;
}

export function normalizeSingbacPreFormDataForWord(
  form: Record<string, any>,
): Record<string, any> {
  const out: Record<string, any> = { ...form };

  const alias = (target: string, source: string) => {
    if (!isFilled(out[target]) && isFilled(out[source])) out[target] = out[source];
  };
  // 등록사무소 주소 별칭(문서마다 표기가 다를 수 있어 양방향 보정)
  alias('registered_office_address', 'company_registered_address');
  alias('company_registered_address', 'registered_office_address');

  buildSubscribers(out);
  buildS156(out);

  return out;
}
